// Translator notes: Fixed phrases and address (engine/src/phrasebook.ts, address.ts).
// Each id is an engine note (`notes.add(text, id, args)`); `args` names its arguments in the order the
// strings take them. Collected by translator/notes.ts (import.meta.glob): adding a note means adding it here.
import { defineNotes } from '../note-defs';

export const notes = defineNotes({
  fixedPhrase: {
    args: ['hv'],
    fi: (a: string[]) => `Kiinteä ilmaus: ”${a[0]}” on valmis fraasi, joten se käännettiin kokonaisena eikä sana sanalta.`,
    en: (a: string[]) => `Fixed expression: “${a[0]}” is a set phrase, so it was translated as a whole, not word by word.`,
  },
  addressToHv: {
    args: [],
    fi: () => 'Puhuttelu lauseen alussa on vokatiivissa, ja kirjeen tapaan määritteet tulevat pääsanan jälkeen, omistusadjektiivi viimeisenä (oppitunti 41).',
    en: () => 'An address at the start of a sentence is in the vocative. As in letters, its modifiers follow the noun, with the possessive last (lesson 41).',
  },
  addressFromHv: {
    args: [],
    fi: () => 'Pilkkua edeltävät sanat luettiin puhutteluksi (vokatiivi), eivät pilkun jälkeisen verbin subjektiksi tai objektiksi.',
    en: () => 'The words before the comma were read as an address (vocative), not as the subject or object of the verb after it.',
  },
});

declare module '../note-defs' {
  interface NoteIds extends Record<keyof typeof notes, true> {}
}
